export class PendingActivationSearchModel {
  id: string;
  name: string;
  expiry: string;
  activation: string;
}
